import { useContext, useEffect, useState } from 'react';
import { Destructor } from 'app/shared/utilities/Destructor';
import { ServicesContext } from 'app/items/shared/context_interface';

/**
 * Returns true if the map is in 'editing mode'
 */
export function useMapEditingStatus() {
    const { mapInputHandlerService } = useContext(ServicesContext);
    const [isMapInEditingMode, setIsMapInEditingMode] = useState(false);

    useEffect(() => {
        const destructor = new Destructor(
            mapInputHandlerService.onActiveHandlerChange(({ isDefault }) => {
                setIsMapInEditingMode(!isDefault);
            }),
        );

        return destructor.destroy;
    }, []);

    return isMapInEditingMode;
}
